// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Ta7","title":"styles_title__2wF7l"};